import { render } from "./Unpaid.vue?vue&type=template&id=061c7c5e"
import script from "./Unpaid.vue?vue&type=script&lang=js"
export * from "./Unpaid.vue?vue&type=script&lang=js"

import "./Unpaid.vue?vue&type=style&index=0&id=061c7c5e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__